export const G15 = 0x537;
export const G15_MASK = 0x5412;
export const G18 = 0x1f25;
